import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ArrowBackIos, SearchOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtons";
import { i18n } from "../../translate/i18n";

const TicketHeader = ({ loading, contact, ticket, onContactClick, onSearchClick }) => {
  const navigate = useNavigate();

  if (loading) return <TicketHeaderSkeleton />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        flexShrink: 0,
      }}
    >
      {/* Row 1 — identity */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          pl: 0.5,
          pr: 1,
          minHeight: 56,
          gap: 0.5,
        }}
      >
        <IconButton
          size="small"
          color="primary"
          onClick={() => navigate("/tickets")}
          sx={{ flexShrink: 0 }}
        >
          <ArrowBackIos fontSize="small" />
        </IconButton>
        <TicketInfo
          contact={contact}
          ticket={ticket}
          onClick={onContactClick}
        />
        <Tooltip title={i18n.t("ticketMessagesSearch.tooltip")}>
          <IconButton
            size="small"
            color="primary"
            onClick={onSearchClick}
            sx={{ flexShrink: 0 }}
          >
            <SearchOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Row 2 — labels + actions */}
      <TicketActionButtons ticket={ticket} />
    </Box>
  );
};

export default TicketHeader;
